import { thirdPartyAuthStore, xoyoAuthStore } from '@src/mobx-store/root-store/auth';
import rootStore from '@src/mobx-store/root-store';
import Toast from '@src/components/toast';
import reload from '@src/utils/reload';
import { computed, observable } from 'mobx';
import AccountInfoStore from '@src/components/account-info/store';
import { props } from '@src/utils/link-store';
import { px2rem } from '@src/utils/rem-util';
import Services from '../../services/general';

export default class BusinessAccountInfoStore extends AccountInfoStore {
  //是否开启剑网3免登
  @observable isIngame;

  /**
   * @param {object} [options] 可替换依赖（聚焦测试注入）。
   * @param {object} [options.sessionStore] 共享活动会话 Store；默认取 root 单例，与页面注入的是同一实例。
   */
  constructor(options = {}) {
    super();
    this.sessionStore = options.sessionStore || rootStore.activitySessionStore;
    this.ensureSessionAccount();
  }

  // 登录态以 get_config 返回的 account（服务端视角）为准：页面 refresh() 重拉 get_config 后
  // 右上角经 observable 自动跟随，规避本地 XPASS 态与服务端 session 漂移（过期/跨标签）。
  // null（未确认/请求中/失败）与 ''（服务端确认未登录）都按未登录展示，方向安全。
  @computed
  get isLogin() {
    return typeof this.sessionStore.account === 'string' ? !!this.sessionStore.account : false;
  }

  /**
   * 用户登录
   * @returns {*}
   */
  @observable
  signIn = () => {
    return window.XPASS.signin();
  };

  /**
   * 退出
   */
  /**
   * 退出
   */
  @observable
  logout = async () => {
    this.isIngame && (await Services.logoutIngame());
    window.XPASS.exit();
  };

  // get_config 的 account 已是服务端脱敏串（如 159***520），关闭本地二次掩码，忠实展示。
  @observable isUsingMaskToUsername = false;

  @computed
  get username() {
    return typeof this.sessionStore.account === 'string' ? this.sessionStore.account : '';
  }

  /**
   * 页面初始化不一定触达共享会话（如规则页只拉 OMNI 内容），账号条在本地有 XPASS 登录态时
   * 自驱动确认一次服务端账号；ensureInitialized 幂等，已在途/就绪的页面零额外请求。
   * 本地未登录时服务端必为空 account，直接短路不发请求。失败仅保持未登录展示，由页面链路负责报错。
   * @returns {void}
   */
  ensureSessionAccount() {
    if (!(typeof window !== 'undefined' && window.XPASS && typeof window.XPASS.u_account === 'string' && window.XPASS.u_account)) {
      return;
    }
    Promise.resolve()
      .then(() => this.sessionStore.ensureInitialized())
      .catch(() => {});
  }

  @computed
  get xoyoAuthUsername() {
    let xoyoUsername = xoyoAuthStore.username;
    if (thirdPartyAuthStore && thirdPartyAuthStore.loginType === 'passport') {
      xoyoUsername = thirdPartyAuthStore.username;
    }
    return xoyoUsername;
  }

  // isAllowLogout 跟随服务端视角登录态：显示账号即可退出，
  // 与 get_config 的 account 同源同步，消除 xoyo JSONP 晚到的时序竞态
  @computed
  get isAllowLogout() {
    return this.isLogin;
  }

  @observable
  onLoginSuccess() {
    reload();
  }

  @observable
  onLogoutSuccess() {
    Toast.success('登出成功');
    reload();
  }

  @props
  style = {
    position: 'absolute',
    top: px2rem('120px'),
    right: px2rem('40px')
  };
}
